import { useSelector } from 'react-redux';
import { isLoading, metricsForAllFarms } from '../store/selectors/grazing-heatmap.selectors';

const CowLocationService = {
  useIsLoading: () => useSelector(isLoading),
  useGrazingHeatmapMetricForAllFarms: () => useSelector(metricsForAllFarms),
};

export default CowLocationService;
